import axios from 'axios';
import config from '../config';
import { translateBackendMessage } from './translateMessage';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
instance.interceptors.request.use(
  (configur) => {
    const token = localStorage.getItem(config.APP_NAME + '_token');
    if (token) {
      configur.headers['Authorization'] = token;
    }
    const mosadToken = localStorage.getItem(config.APP_NAME + '_mosadToken');
    if (mosadToken) {
      configur.headers['MosadAuthorization'] = mosadToken;
    }
    return configur;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Handle 401 Unauthorized
      // if (error.response.status === 401) {
      //   store.dispatch(logout());
      //   window.location.href = '/login';
      // }

      // Handle other errors
      const rawMessage = error.response.data.message || 'שגיאה לא ידועה';
      const errorMessage = translateBackendMessage(rawMessage);
      error.response.data.message = errorMessage;
      console.error('API Error:', errorMessage);
    } else if (error.request) {
      // Handle network errors
      console.error('Network Error:', error.request);
    } else {
      // Handle other errors
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default instance; 